import Dashboard from "../shared/components/Dashboard/dashboard";


export default function Dashboardpage () {

    return(
       <Dashboard/>
    )
}